import { GlobalState } from '@leverege/ui-redux'
import React from 'react'

import Theme from './theme'
import MapSettingsActionMutator from './mutators/MapSettingsActionMutator'
import ActionPersonaMutator from './mutators/ActionPersonaMutator'
import LimitToRolesMutator from './mutators/LimitToRolesMutator'

const adminHandles = ( context ) => {
  // hide for all but steve on mobile
  // const { clientProps : { mobile } } = context
  const hasDefault = !!GlobalState.get()?.ui?.personas?.some( p => p.name === 'default' )
  // only non-custom persona user's when on mobile
  return hasDefault
}

function create( env = process.env ) {

  const isDev = process.env.IS_DEV === 'true'

  return {
    uiName : process.env.UI_NAME,
    r4kEnabled : process.env.R4K_ENABLED,
    molten : {
      splashClass : Loading,
    },
    theme : {
      theme : Theme,
      appearanceProjectId : process.env.APPEARANCE_PROJECT_ID || '3A48uiQ626esPO2PcnwmaN',
      useActiveTheme : isDev
    },
    maps : {
      apiKey : process.env.GOOGLE_MAPS_API_KEY,
      mapId : process.env.GOOGLE_MAPS_MAP_ID,
    },
    api : {
      host : process.env.IMAGINE_HOST || 'http://localhost:8181',
      systemId : process.env.SYSTEM_ID,
      projectId : process.env.PROJECT_ID,
    },
    googleAnalytics : { 
      trackerId : process.env.GOOGLE_ANALYTICS_TRACKER_ID,
    },
    sentry : {
      dsn : process.env.SENTRY_DSN,
      enabled : !process.env.WEBPACK_SERVE,
      environment : process.env.DEPLOYMENT_TARGET,
      replaysSessionSampleRate : isDev ? 0 : 0.01,
      replaysOnErrorSampleRate : isDev ? 0.1 : 0.5
    },
    plugins : {
      // LoadConfig will use these and call Config.set()
      config : {
        'blueprint.link.store.products.SimpleSearchScreen' : {
          layout : {
            sort : 'p.1',
            sectionName : 'Inventory'
          }
        },
        'molten.dataViewers.layout.RenameLayoutAction' : {
          handles : adminHandles
        },
        'molten.dataViewers.layout.DeleteLayoutAction' : {
          handles : adminHandles
        },
        'molten.dataViewers.layout.SetLayoutAsDefaultAction' : {
          handles : adminHandles
        },
        StationImageRenderer : {
          gcsBucketUrl : env.GCS_STORAGE_BUCKET_URL || process.env.GCS_STORAGE_BUCKET_URL
        },
        GroupScreen : {
          defaultPerPage : 200
        },
        OperationStates : {
          operationStates : {
            1 : 'Shipment',
            2 : 'Factory Default',
            8 : 'Unpaired',
            9 : 'Paired',
            10 : 'Sold',
            11 : 'Active Theft Recovery',
            12 : 'Disabled'
          }          
        },
        Intercom : {
          appId : env.INTERCOM_APP_ID || process.env.INTERCOM_APP_ID
        },
        LayoutViewerSelector : {
          allowEditing : 'default'
        },
        mapBoxPosition : {
          selectedRezoomThreshold : 16
        },
        ResponsiveDataViewer : {
          minWidth : 640
        },
        AccountScreen : {
          redirectUrl : '/account/profile'
        },
        ProfileScreen : {
          usernameSubtitle : 'This is the email associated with your account. This cannot be changed.',
          usernameLabel : 'Account Email'
        },
        LostScreen : {
          image : [
            'https://molten-ui-assets.storage.googleapis.com/404-UFO.png',
            'https://molten-ui-assets.storage.googleapis.com/404-Earth.png',
            'https://molten-ui-assets.storage.googleapis.com/404-Page.png',
            'https://molten-ui-assets.storage.googleapis.com/404-Ghost.png'
          ]
        }
      },
      excludes : [
      ],
      mutators : [
        // array of functions( type, plugin ) that can return the plugin to continue,
        // null to exclude it, or a plugin to replace it.
        MapSettingsActionMutator,
        ActionPersonaMutator,
        LimitToRolesMutator
      ]
    },
    actions : {
      'petsmart.dataViewers.stations.StationsCardDataViewerEditor' : {
        limitToRoles : [
          'default'
        ]
      },
      'ps.dataViewers.aisles.AisleCardDataViewer' : {
        limitToRoles : [
          'default'
        ]
      },
      'ps.dataViewers.rooms.RoomCardDataViewer' : {
        limitToRoles : [
          'default'
        ]
      },
      'molten.dataViewers.list.EditSettingsAction' : {
        hideForNonAdmin : true
      },
      'molten.dataViewers.table.EditSettingsAction' : {
        hideForNonAdmin : true
      },
      'molten.screens.group.search.SearchSettings' : {
        hideForNonAdmin : true
      },
      'molten.dataViewers.details.EditDetailsAction' : {
        hideForNonAdmin : true
      },
      'molten.dataViewers.map.EditSettingsAction' : {
        hideForNonAdmin : true
      },
      'molten.dataViewers.history.EditSettingsAction' : {
        hideForNonAdmin : true
      },
      'molten.dataViewers.aggregations.ContainerEditSettingsAction' : {
        hideForNonAdmin : true
      },
      'molten.dataViewers.aggregations.EditSettingsAction' : {
        hideForNonAdmin : true
      },
      'molten.dataViewers.layout.DefaultLayoutAction' : {
        hideForNonAdmin : true
      },
      'molten.dataViewers.layout.SaveAsLayoutAction' : {
        hideForNonAdmin : true
      },
      'molten.dataViewers.layout.ResetLayoutAction' : {
        hideForNonAdmin : true
      },
      'molten.dataViewers.layout.SaveLayoutAction' : {
        hideForNonAdmin : true
      },
      'list.SettingsAction' : {
        hideForNonAdmin : true
      },
      'table.SettingsAction' : {
        hideForNonAdmin : true
      },
      'search.EditSearchSettingsActionMobile' : {
        hideForNonAdmin : true
      },
      'search.EditSearchSettingsAction' : {
        hideForNonAdmin : true
      },
      'molten.mapDataViewer.EditSettingsAction' : {
        hideForNonAdmin : true
      },
      'link.desktop.Settings' : {
        hideForNonAdmin : true
      },
      'link.mobile.Settings' : {
        hideForNonAdmin : true
      },
      'dataCard.SettingsAction' : {
        hideForNonAdmin : true
      },
      'dashboard.ToggleEditingAction' : {
        hideForNonAdmin : true
      },
      'aggregations.SettingsAction' : {
        hideForNonAdmin : true
      },
      'layout.AdvancedSettingsAction' : {
        hideForNonAdmin : true
      }
    }
  }
}

function Loading( props ) {
  return React.createElement( 'div', null, 'Loading Molten...' )
}
export default {
  create
}
